import { render, staticRenderFns } from "./PrkBeamSyllabusesAdmin.vue?vue&type=template&id=672d90c1&"
import script from "./PrkBeamSyllabusesAdmin.vue?vue&type=script&lang=js&"
export * from "./PrkBeamSyllabusesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports